export default "__VITE_ASSET__Diucpn7v__"